module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "cont"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "cont1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1"
    }
  }, [_vm._v("WELCOME TO SUCCESSFUL GARDENING IN UTAH!")])]), _vm._v(" "), _c('p', {
    staticClass: "cont2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter2"
    }
  }, [_vm._v("PROBLEMS AND SOLUTIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "cont2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SOLUTIONS FOR SUCCESSFUL GARDENING IN UTAH")])]), _vm._v(" "), _c('p', {
    staticClass: "cont2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SEEDRENAISSANCE.COM GUIDE TO BASIC PLANTING IN THE ROCKY MOUNTAIN WEST")])]), _vm._v(" "), _c('p', {
    staticClass: "cont2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OTHER INFORMATION")])]), _vm._v(" "), _c('p', {
    staticClass: "cont2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/aboutauthor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ABOUT THE AUTHOR")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53e656ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/content.vue
// module id = 66
// module chunks = 0